import type { DriveAssessmentConfigs } from '../types'

const assessmentNames: Record<string, string> = {
  aptitude_reasoning: 'Aptitude & Reasoning', fundamentals: 'Technical Knowledge',
  coding: 'Coding Assessment', 'case-study': 'Case Study', case_study: 'Case Study',
  quantitative_ability: 'Quantitative Ability', logical_reasoning: 'Logical Reasoning',
  verbal_ability: 'Verbal Ability', cloud_fundamentals: 'Cloud Fundamentals',
  presales_fundamentals: 'Pre-Sales Fundamentals', english_communication: 'English Communication',
  ai_fundamental: 'AI Fundamental', aiml_assignment: 'AI/ML Assignment',
}

export function testGuidelines(proctoringEnabled = true): string[] {
  return [
    'Ensure you have a stable internet connection throughout the test.',
    proctoringEnabled ? 'Keep your camera and microphone enabled for AI proctoring.' : 'Complete this assessment independently.',
    'Do not switch tabs, open new windows, or use external resources.',
    'Ensure you are in a quiet, well-lit environment.',
    'The test will auto-submit when time expires.',
  ]
}

export function testSections(configs: DriveAssessmentConfigs | null | undefined) {
  return Object.entries(configs ?? {}).flatMap(([type, config]) => {
    if (!config) return []
    const questions = Number(config.num_questions)
    const minutes = Number(config.duration_minutes)
    if (!Number.isFinite(questions) || questions < 0 || !Number.isFinite(minutes) || minutes <= 0) return []
    return [{ type, name: assessmentNames[type] ?? type.replace(/[_-]/g, ' '), questions, minutes }]
  })
}

export function automaticTestInstructions(configs: DriveAssessmentConfigs | null | undefined): string {
  const sections = testSections(configs)
  const summary = sections.map(section => `${section.name}: ${section.questions} questions, ${section.minutes} minutes.`)
  if (sections.length) summary.push(`Total: ${sections.reduce((n, s) => n + s.questions, 0)} questions, ${sections.reduce((n, s) => n + s.minutes, 0)} minutes.`)
  return [...summary, ...testGuidelines(!sections.length || !sections.every(section => section.type === 'aiml_assignment'))].join('\n')
}
